import React from "react";
import { EditorShortcutContext } from "./EditorShortcutContext";

export const useEditorShortcuts = () => {
  const context = React.useContext(EditorShortcutContext);
  if (context === undefined) {
    throw new Error(
      "useEditorShortcuts must be used within a EditorShortcutProvider",
    );
  }
  return context;
};
